<template>
  <main class="container-fluid" style="max-width:600px">
    <div class="row mb-3 g-3 mt-3">
      <div class="col">
        <h5><strong>Ativação de conta</strong></h5>
        <div class="a-divider a-divider-break"></div>
      </div>
    </div>

    <div class="row m-3" v-if="erro">
      <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
        {{ erro }}
      </div>
    </div>

    <div class="row m-3" v-if="sucesso">
      <div class="col card my-2 badge-success text-center p-3 text-uppercase mt-3">
        {{ sucesso }}
      </div>
    </div>
    <form @submit.prevent="validarCodigo" class="text-center">
      <div class="row mb-3 g-3">
        <div class="col">
          <label for="usuario" class="form-label">CPF ou CNPJ</label>
          <input class="form-control text-center" type="text" id="usuario" placeholder="000.000.000-00"
            :disabled="!!this.$store.state.user" v-model="register.usuario"
            v-mask="['###.###.###-##', '##.###.###/####-##']" required />
        </div>
      </div>

      <div class="row mb-3 g-3">
        <div class="col">
          <label for="codigo" class="form-label">Código de validação</label>
          <input class="form-control text-center" v-model="codigo" placeholder="* * * * * *" id="codigo"
            v-mask="'######'" required />
          <smal>
            <a href="#" @click="reenviarCodigoAtivacao()">
              <small>reenviar código</small>
            </a>
          </smal>
        </div>
      </div>

      <p class="mt-2" style="font-size: 0.9rem;">
        O código foi enviado para o e-mail e telefone informado no cadastro.
      </p>
      <p class="mt-2" style="font-size: 0.9rem;">
        Caso sua conta seja PJ, o código foi enviado para o e-mail e telefone do responsável.
      </p>

      <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
        <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)">
          VOLTAR
        </button>
        <button class="btn btn_color_system py-2 px-5 mt-4" type="submit">
          VALIDAR
        </button>
      </div>


    </form>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import { sha256 } from "../shared/helpers/helpers";

export default {
  name: "ValidarCodigo",
  components: {},
  data() {
    return {
      MODULOS: window.MODULOS,
      login: {
        user: "",
        password: ""
      },
      register: {
        nome: "",
        usuario: "",
        email: "",
        celular: "",
        password: "",
        dataNascimento: ""
      },
      codigo: "",
      sucesso: "",
      erro: ""

    };
  },
  mounted() {
    this.register.usuario = this.$route.query.cpfCnpj;
    if (!this.register.usuario) {
      const { usuario } = this.$store.state.user || this.register;
      this.register.usuario = usuario;
    }
  },
  methods: {
    validarCodigo() {
      this.erro = "";
      this.loading = true;
      const { usuario, password } = this.$store.state.user || this.register;
      apiService
        .validarCodigo(
          {
            codigo: this.codigo
          },
          {
            usuario: this.removeMask(usuario),
            hashSenha: sha256(password)
          }
        )
        .then(response => {
          this.$store.dispatch("loginApp", response);

          if (this.$route.query.nextUrl != null) {
            this.$router.push(this.$route.query.nextUrl);
          } else {
            this.$router.push(`/`);
          }
        }).catch(error => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    reenviarCodigoAtivacao() {
      apiService
        .reenviarCodigoAtivacao(this.removeMask(this.register.usuario))
        .then(() => {
          this.sucesso = "Código enviado com sucesso."
        });
    },
    removeMask(n) {
      return n.replace(/\D/gm, "");
    }
  }
};
</script>
<style scoped lang="scss">
button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-secundaria);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }
}
</style>
